
export const services = [
    {
        title: "Technology Enthusiast",
        icon: 'https://csgeeek.github.io/web.png',
    },
    {
        title: "Software Engineer",
        icon: 'https://csgeeek.github.io/web.png',
    },
    {
        title: "Photographer",
        icon: 'https://csgeeek.github.io/web.png',
    },
];

export const name = 'Sujal';

export const experiences = [
    {
        'company': 'GBJ BUZZ',
        'role': 'Web Developer (Intern)',
        'duration': 'Jan 2025 - Present',
        'logo': 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQsH7hyN4U5HpLOOSOuC-RWPtNf-ti8QlzcIg&s',
        'points': [
            'Contributed to high-impact projects as both frontend and backend engineer, ensuring optimal functionality and user experience.',
            'Spearheaded the development of ”Libex,” a platform leveraging MERN, Sanity.io, and Firebase, enabling students to enhance skills through curated courses and gain hands-on experience via internship opportunities.',
            'Delivered scalable and efficient solutions, achieving a 25% improvement in project turnaround time and user engagement.',
        ],
        'url': 'https://www.gbjbuzz.com/',
    },
    {
        'company': 'WebStack Academy',
        'role': 'MERN Stack Developer(Intern)',
        'duration': 'June 2024 - Sept 2024',
        'logo': 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTKgY5xC2kbgmkuVxyw7_aZEO0oIa2kZ6hXsQ&s',
        'points': [
            'Enhanced MERN stack expertise and acquired hands-on experience in Docker, DevOps practices, and AWS as part of a guided learning program under senior developers.',
            'Designed and implemented ”Foodify,” a responsive food ordering platform, optimizing user interface and backend workflows to ensure seamless ordering experiences.',
            'Successfully collaborated in a remote setting, meeting deadlines and achieving a 20% increase in operational efficiency through refined development practices.',
        ],
        'url': 'https://www.webstackacademy.com/#home',
    },
    {
        'company': 'CodSoft',
        'role': 'Web Dev Intern',
        'duration': 'DEC 2023 - JAN 2024',
        'logo': 'https://assets.zyrosite.com/cdn-cgi/image/format=auto,w=1200,h=630,fit=crop,f=jpeg/Aq20eV79zLfpXV6b/1685789339697-YrDL60zzRBfzM6Wr.jpg',
        'points': [
            'Gained experience with Git version control contributing to the development and maintenance of code repositories.',
            'Developed multiple User Friendly Projects like personal portfolio, landing page, calculator etc. 📱.',
            'Technology Used - HTML, CSS, JavaScript, NodeJs, GIT'
        ],
        'url': 'https://www.codsoft.in/',
    },
]

